import {ReactElement} from 'react';
import BaseLayout from '../../Components/shared/BaseLayout';
import ActivatedContent from '../../Components/Activated/ActivatedContent';

const Activated = (): ReactElement => {
    return (
        <BaseLayout>
            <ActivatedContent/>
        </BaseLayout>
    );
};

export {Activated as TestableActivated};
export default Activated;
